import React, { ReactChild } from 'react'
import { styled } from '@fareye/ui'

const TimeLineFrame: any = styled.div`
  ${(props: any) => {
    const isHorizontal = props.variant.indexOf('horizontal') > -1
    const size = props.size

    return {
      ...props.theme.timeline[size].frame,
      ...(isHorizontal
        ? {
            'flex-direction': 'row',
            'overflow-x': 'auto',
            'overflow-y': 'hidden'
          }
        : { 'overflow-x': 'hidden', 'overflow-y': 'auto' }),
      ...props.styles
    }
  }};
`
export const TimeInstance: any = styled.div`
  ${(props: any) => {
    const size = props.size
    const isHorizontal = props.variant.indexOf('horizontal') > -1
    return {
      ...props.theme.timeline[size].timeInstance,
      ...(isHorizontal ? props.theme.timeline[size].timeInstanceH : {}),
      ...props.styles
    }
  }};
`

export const Dot: any = styled.div`
  ${(props: any) => {
    const size = props.size
    const isDotted = props.variant.indexOf('dotted') > -1
    const isHorizontal = props.variant.indexOf('horizontal') > -1
    return {
      ...props.theme.timeline[size].dot,
      ...(isHorizontal ? props.theme.timeline[size].dotH : {}),
      ...(isDotted ? props.theme.timeline[size].dotDotted : {}),
      ...props.styles
    }
  }};
`

export const Line: any = styled.span`
  ${(props: any) => {
    const size = props.size
    const isDotted = props.variant.indexOf('dotted') > -1
    const isHorizontal = props.variant.indexOf('horizontal') > -1
    return {
      ...props.theme.timeline[size][isHorizontal ? 'lineH' : 'line'],
      ...(isDotted ? props.theme.timeline[size].lineDotted : {}),
      ...props.styles
    }
  }};
`
interface ITimeLineProps {
  styles?: {
    timeInstance?: React.CSSProperties
    dot?: React.CSSProperties
    frame?: React.CSSProperties
    line?: React.CSSProperties
  }
  variant?: string
  children: ReactChild
  size: 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'
}

export function TimeLine(props: ITimeLineProps) {
  const { children, styles, size, variant } = props
  return (
    <TimeLineFrame size={size} variant={variant} style={styles && styles.frame}>
      {children}
    </TimeLineFrame>
  )
}
